export default "__VITE_ASSET__3duzDyNm__"